import React, { useState, useEffect } from "react";
import "./NavigationBar.css";

function NavigationBar() {
    const [scrolled, setScrolled] = useState(false);
    const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
    const [activeSection, setActiveSection] = useState('home');

    useEffect(() => {
        const handleScroll = () => {
            setScrolled(window.scrollY > 10);
            
            // Get all sections
            const sections = ['home', 'about', 'services', 'gallery', 'persons', 'contact'];
            
            // Find the current section
            for (const section of sections) {
                const element = document.getElementById(section);
                if (element) {
                    const rect = element.getBoundingClientRect();
                    if (rect.top <= 100 && rect.bottom >= 100) {
                        setActiveSection(section);
                        break;
                    }
                }
            }
        };

        window.addEventListener("scroll", handleScroll);
        return () => window.removeEventListener("scroll", handleScroll);
    }, []);

    const handleLinkClick = (section) => {
        setMobileMenuOpen(false);
        setActiveSection(section);
    };

    return (
        <nav className={`nav ${scrolled ? "scrolled" : ""}`}>
            <div className="nav-container">
                <div className="nav-logo">
                    <a href="/">
                        <img src="/images/logo/logo9.png" alt="Logo" className="logo" />
                    </a>
                </div>

                <div className={`nav-menu ${mobileMenuOpen ? "open" : ""}`}>
                    <ul>
                        <li><a href="#home" onClick={() => handleLinkClick('home')} className={activeSection === 'home' ? 'active' : ''}>ΑΡΧΙΚΗ</a></li>
                        <li><a href="#about" onClick={() => handleLinkClick('about')} className={activeSection === 'about' ? 'active' : ''}>ΓΙΑ ΕΜΑΣ</a></li>
                        <li><a href="#services" onClick={() => handleLinkClick('services')} className={activeSection === 'services' ? 'active' : ''}>ΥΠΗΡΕΣΙΕΣ</a></li>
                        <li><a href="#gallery" onClick={() => handleLinkClick('gallery')} className={activeSection === 'gallery' ? 'active' : ''}>ΕΙΚΟΝΕΣ</a></li>
                        <li><a href="#persons" onClick={() => handleLinkClick('persons')} className={activeSection === 'persons' ? 'active' : ''}>Η ΟΙΚΟΓΕΝΕΙΑ ΜΑΣ</a></li>
                        <li><a href="#contact" onClick={() => handleLinkClick('contact')} className={activeSection === 'contact' ? 'active' : ''}>ΕΠΙΚΟΙΝΩΝΙΑ</a></li>
                    </ul>
                </div>

                <div className="mobile-menu-btn" onClick={() => setMobileMenuOpen(!mobileMenuOpen)}>
                    <i className={`fas ${mobileMenuOpen ? "fa-times" : "fa-bars"}`}></i>
                </div>
            </div>
        </nav>
    );
}

export default NavigationBar;
